//
// Copyright 2026 ArangoDB GmbH, Cologne, Germany
// All rights reserved. See LICENSE.md in the project root for license information.
//
import { TaxClassification } from "../../api/lib";

export const taxClassificationOptions = [
  { key: "individual", text: "Individual (private person)", value: TaxClassification.TAX_CLASSIFICATION_INDIVIDUAL },
  { key: "eu_corp", text: "EU Corporation", value: TaxClassification.TAX_CLASSIFICATION_EU_CORPORATION },
];

// The API serializes enums as their string name (e.g. "TAX_CLASSIFICATION_EU_CORPORATION"),
// while the generated TS enum is numeric — so tax_classification must be normalized before it
// is compared, used as a dropdown value, or shown, or it never matches. Mirrors
// normalizePaymentState in EverestInvoices.tsx.
export const normalizeTaxClassification = (raw: unknown): TaxClassification | undefined => {
  if (raw == null || raw === "") {
    return undefined;
  }
  if (typeof raw === "number") {
    return raw as TaxClassification;
  }
  const byName = TaxClassification[raw as keyof typeof TaxClassification];
  return typeof byName === "number" ? byName : undefined;
};

// Human-readable label for a tax classification (accepts the API string or the numeric enum).
export const taxClassificationLabel = (raw: unknown): string => {
  const tc = normalizeTaxClassification(raw);
  return taxClassificationOptions.find((o) => o.value === tc)?.text ?? "";
};
